// extracted by mini-css-extract-plugin
export default {"image":"DamageImageSlider_image__aGcJJ","progressContainer":"DamageImageSlider_progressContainer__iH-l-"};